var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.label || "Resultate"))]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","min":0},domProps:{"value":_vm.realValue},on:{"input":_vm.emitFilter}})])}
var staticRenderFns = []

export { render, staticRenderFns }